<template>
<div class="container">

    <div class="e2018_banner">
      <div class="text">&bigstar; <span>Election 2020</span> &bigstar;</div>
    </div>

    <div class="e2018_top_results">
      
      <div class="top_result">
        <div class="title"><a :href="`${E2020_PUB_PATH}/president/`">President</a></div>
        <div class="score">
          <div v-if="loading" class="e2018_spinner"><div><div></div></div></div>
          <div v-show="first_load_done" class="party dem">
            <div class="title"><a :href="`${E2020_PUB_PATH}/president/`">Biden/Harris</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/president/`" v-html="electoral_summary.Biden"></a></div>
          </div>
          <div v-show="first_load_done" class="party gop">
            <div class="title"><a :href="`${E2020_PUB_PATH}/president/`">Trump/Pence</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/president/`" v-html="electoral_summary.Trump"></a></div>
          </div>
        </div>
      </div>
      
      <!--<div class="top_result">
        <div class="title"><a :href="`${E2020_PUB_PATH}/governor/`">Governors PP</a></div>
        <div class="score">
          <div v-if="loading" class="e2018_spinner"><div><div></div></div></div>
          <div v-show="first_load_done" class="party dem">
            <div class="title"><a :href="`${E2020_PUB_PATH}/governor/`">Democrats</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/governor/`" v-html="won_seats.governor.dem + net_display(net_seats.governor.dem)"></a></div>
          </div>
          <div v-show="first_load_done" class="party gop">
            <div class="title"><a :href="`${E2020_PUB_PATH}/governor/`">Republicans</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/governor/`" v-html="won_seats.governor.gop + net_display(net_seats.governor.gop)"></a></div>
          </div>
        </div>
      </div>-->
      
      <div class="top_result">
        <div class="title"><a :href="`${E2020_PUB_PATH}/senate/`">U.S. Senate</a></div>
        <div class="score">
          <div v-if="loading" class="e2018_spinner"><div><div></div></div></div>
          <div v-show="first_load_done" class="party dem">
            <div class="title"><a :href="`${E2020_PUB_PATH}/senate/`">Democrats</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/senate/`" v-html="won_seats.senate.dem + '*' + net_display(net_seats.senate.dem)"></a></div>
          </div>
          <div v-show="first_load_done" class="party gop">
            <div class="title"><a :href="`${E2020_PUB_PATH}/senate/`">Republicans</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/senate/`" v-html="won_seats.senate.gop + net_display(net_seats.senate.gop)"></a></div>
          </div>
        </div>
      </div>

      <div class="top_result">
        <div class="title"><a :href="`${E2020_PUB_PATH}/house/`">U.S. House</a></div>
        <div class="score">
          <div v-if="loading" class="e2018_spinner"><div><div></div></div></div>
          <div v-show="first_load_done" class="party dem">
            <div class="title"><a :href="`${E2020_PUB_PATH}/house/`">Democrats</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/house/`" v-html="won_seats.house.dem + net_display(net_seats.house.dem)"></a></div>
          </div>
          <div v-show="first_load_done" class="party gop">
            <div class="title"><a :href="`${E2020_PUB_PATH}/house/`">Republicans</a></div>
            <div class="score"><a :href="`${E2020_PUB_PATH}/house/`" v-html="won_seats.house.gop + net_display(net_seats.house.gop)"></a></div>
          </div>
        </div>
      </div>

    </div>

    <div class="e2018_stars">********2020********</div>

</div>
</template>

<script>

import ElectionNightMixin from './ElectionNightMixin.js';

export default {
    name: 'rc-widget-live-results-alpha-1',
    mixins: [
        ElectionNightMixin,
    ],
    data() {
        return {
            "loading_interval" : 0,
            "loading" : true,
            "first_load_done" : false,
            "president_summary" : {},
            "electoral_summary" : {
                "Biden" : 0,
                "Trump" : 0,
            },
            "won_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            },
            "net_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            }
        };
    },
    created : function() {

        this.get_data_for_alpha_1();

        // Start refresh cron
        this.loading_interval = setInterval(() => {
            this.fetch_data();
        }, this.rcp_refresh_interval * 1000);
    },
    methods: {

        fetch_data : function() {

            if(!this.loading) {
                this.get_data_for_alpha_1();
            }
        },

        get_data_for_alpha_1 : function() {

            this.loading = true;

            // Retrieve live results data
            this.rcp_hp_fetch_data((response) => {

                // Successfully retrieved data
                this.won_seats = response.data.won_seats;
                this.net_seats = response.data.net_seats;
                this.president_summary = response.data.president_summary;
                this.electoral_summary = response.data.electoral_summary;

                this.first_load_done = true;
                this.loading = false;

            });
        },

    },
}
</script>

<style lang="scss">

</style>